import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

export const NotAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const hasToken = localStorage.getItem("Token") || sessionStorage.getItem("Token");
  const hasProfile = localStorage.getItem("UserProfile") || sessionStorage.getItem("UserProfile");
  if (!hasProfile || !hasToken) {
    return true;
  } else {
    router.navigateByUrl("/home");
    return false;
  }
};
